<template>
  <div id="app">
    <div class="header" style="min-width: 1260px">
      
      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
        menu-trigger="click"
        style="opacity: 0.9;"
        background-color="#4E5457"
        text-color="#FFFFFF"
        unique-opened
        active-text-color="#1890FF">
        <el-menu-item index="1">官网首页</el-menu-item>
        <el-submenu index="2" :popper-append-to-body="false">
          <template slot="title">解决方案</template>
          <el-menu-item index="2-1">系统架构</el-menu-item>
          <el-menu-item index="2-2">收费流程</el-menu-item>
          <el-menu-item index="2-3">充电车位</el-menu-item>
          <el-menu-item index="2-4">零散车位</el-menu-item>
          <el-menu-item index="2-5">运营服务</el-menu-item>
        </el-submenu>
        <el-submenu index="3" :popper-append-to-body="false">
          <template slot="title">产品中心</template>
          <el-menu-item index="3-1">智能硬件</el-menu-item>
          <el-menu-item index="3-2">软件平台</el-menu-item>
        </el-submenu>
        <el-menu-item index="4">业务合作</el-menu-item>
        <el-menu-item index="5">关于我们</el-menu-item>
      </el-menu>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "Layout",
  data() {
    return {
      activeIndex: "",
      scroll: "",
      timer: "",
      currentMenu: "官网首页",
    };
  },
  methods: {
    handleSelect(key) {
      switch (key) {
        case "1":
          this.$router.push({ name: "Index" });
          break;
        case "2-1":
          window.location.hash = "#系统架构";
          break;
        case "2-2":
          window.location.hash = "#收费流程";
          break;
        case "2-3":
          window.location.hash = "#充电车位";
          break;
        case "2-4":
          window.location.hash = "#零散车位";
          break;
        case "2-5":
          window.location.hash = "#运营服务";
          break;
        case "3-1":
          window.location.hash = "#智能硬件";
          break;
        case "3-2":
          window.location.hash = "#软件平台";
          break;
        case "4":
          window.location.hash = "#关于我们";
          break;
        case "5":
          window.location.hash = "#关于我们";
          break;
      }
    },
    handleScroll() {
      this.scroll = document.documentElement.scrollTop + document.body.scrollTop;
    },
  },
  mounted() {
    this.$router.push({ name: "Index" });
    window.addEventListener("scroll", this.handleScroll);
  },
};
</script>

<style scoped>
#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: var(--vt-c-bg);
  transition: background-color 0.5s;
  padding-top: var(--vt-banner-height);
}
.header {
  margin: auto;
  width: 100%;
}
.el-menu {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1530px;
  margin: auto auto -82px auto;
}
/deep/ .el-menu-demo{
  width:1530px;
  margin:auto;
}
/deep/ .el-menu--popup{
  min-width: 120px;
}
/deep/ .el-menu-item{
  min-width: 120px;
}
</style>
